import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { BoletoIcon } from '~/components/icons/boleto-icon';
import { PixIcon } from '~/components/icons/pix-icon';
import { colors } from '~/theme';

interface Step {
  title: string;
  description?: string;
}

const STEPS: Step[] = [
  {
    title: 'Selecione se quer validar um boleto ou um código Pix',
    description: 'Clique em um dos botões abaixo',
  },
  {
    title: 'Copie a linha digitável do boleto ou o código Pix e cole no campo',
    description: 'No visualizador de cobranças da CUB, você pode usar os botões de copiar código/número',
  },
  {
    title: 'Pronto! Informamos na hora se a cobrança é autêntica',
  },
];

export const OnboardingScreen = () => {
  const navigate = useNavigate();

  return (
    <Stack spacing={3} px={3} py={4}>
      <Typography variant="h1" fontWeight={700} sx={{ fontSize: '16px', color: colors.neutralBluish600 }}>
        SIGA OS PASSOS:
      </Typography>

      <Stack spacing={3} divider={<Box sx={{ borderBottom: `1px solid ${colors.gray}` }} />}>
        {STEPS.map((step, index) => {
          const isLastStep = !step.description;
          const stepColor = isLastStep ? colors.info.dark : colors.neutralBluish600;

          return (
            <Stack key={step.title} direction="row" spacing={2}>
              <Box
                width={32}
                height={32}
                minWidth={32}
                borderRadius="50%"
                border={`1px solid ${stepColor}`}
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{ backgroundColor: isLastStep ? colors.info.light : 'transparent' }}
              >
                <Typography variant="body2" fontWeight={700} sx={{ color: stepColor }}>
                  {index + 1}
                </Typography>
              </Box>
              <Stack spacing={0.5}>
                <Typography variant="body1" fontWeight={700} sx={{ color: stepColor }}>
                  {step.title}
                </Typography>
                {step.description && (
                  <Typography variant="body2" sx={{ color: colors.neutralBluish600 }}>
                    {step.description}
                  </Typography>
                )}
              </Stack>
            </Stack>
          );
        })}
      </Stack>

      <Stack spacing={2}>
        <Button
          variant="contained"
          size="large"
          fullWidth
          startIcon={<BoletoIcon sx={{ fontSize: '16px' }} />}
          onClick={() => navigate('/validar-boleto')}
        >
          VALIDAR BOLETO
        </Button>
        <Button
          variant="outlined"
          size="large"
          fullWidth
          startIcon={<PixIcon viewBox="0 0 16 16" sx={{ fontSize: '16px' }} />}
          onClick={() => navigate('/validar-pix')}
        >
          VALIDAR PIX
        </Button>
      </Stack>
    </Stack>
  );
};
